import cn from 'classnames';
import { useEffect } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useThemeSettingsContext } from 'src/components/settings/ThemeSettingsContext';
import { useWorkspaceFeaturesSettings } from 'src/hooks/useWorkspace';
import { useIsAppCollaborate } from 'src/state';
import { NavRecents } from '../NavRecents/NavRecents';
import { NavScroolbar } from '../shared/styles';
import { BoardsNav } from './BoardsNav';
import { DocsNav } from './DocsNav';
import { NavDrive } from './NavDrive';
import { TodosNav } from './TodosNav';

export const NavCollaborate = () => {
  const { user } = useAuthContext();
  const { onChangeColorPresets } = useThemeSettingsContext();
  const isAppCollaborate = useIsAppCollaborate();
  const { smartTodos } = useWorkspaceFeaturesSettings();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    onChangeColorPresets('collaborate');
  }, [user?.settings?.themeMode]);

  return (
    <NavScroolbar
      className={cn({ isAppCollaborate })}
      // @ts-expect-error role is not supported by Scrollbar
      // biome-ignore lint/a11y/useSemanticElements: <explanation>
      role="navigation"
      aria-label="Main"
    >
      {!isAppCollaborate && <NavRecents />}
      {smartTodos && <TodosNav />}
      <BoardsNav />
      <DocsNav />
      <NavDrive />
    </NavScroolbar>
  );
};
